export default "https://sdk.cotreat.ai/close-33938e47.svg";